

export const Navigation = (props) => {
  return (
    <nav id='menu' className='navbar navbar-default navbar-fixed-top'>
      <div className='container' >
        <div className='navbar-header'>
          <button
            type='button'
            className='navbar-toggle collapsed'
            data-toggle='collapse'
            data-target='#bs-example-navbar-collapse-1'
          >
            {' '}
            <span className='sr-only'>Toggle navigation</span>{' '}
            <span className='icon-bar'></span>{' '}
            <span className='icon-bar'></span>{' '}
            <span className='icon-bar'></span>{' '}
          </button>
          <a href='../#header'className='page-scroll' ><img src='proteinarium_2_logo.jpg' id='navbarimglink' className='navbar-brand page-scroll'  style={{padding: "0px 0px"}}  /></a>
          {' '}
        </div>

        <div
          className='collapse navbar-collapse'
          id='bs-example-navbar-collapse-1'
        >
          <ul className='nav navbar-nav navbar-right'>
            {/* <li>
              <a href='/newProject' className='page-scroll'>
                <b>NEW SESSION</b>
              </a>
            </li> */}
            <li>
              <a href='https://docs.google.com/document/d/1xtR5DrNvEvItuW8sJZtBDssiogHlPAHMzZNJmCfWFBo/edit?usp=sharing' target='_blank' className='page-scroll'>
                Documentation
              </a>
            </li>
            <li>
              <a href='../#features' className='page-scroll'>
                Features
              </a>
            </li>
            
            

            {/*<li>*/}
            {/*  <a href='../#portfolio' className='page-scroll'>*/}
            {/*    Usage*/}
            {/*  </a>*/}
            {/*</li>*/}
            <li>
              <a href='../#about' className='page-scroll'>
                Sponsors
              </a>
            </li>
            <li>
              <a href='../#contact' className='page-scroll'>
                Contact
              </a>
            </li>
          </ul>
        </div>
      </div>
    </nav>
  )
}
